export function mergeById(existing, incoming) {
  const mergedResults = new Map();
  [existing, incoming].forEach(results => {
    results.forEach(result => {
      var _mergedResults$get;
      mergedResults.set(result.id, Object.assign({}, (_mergedResults$get = mergedResults.get(result.id)) !== null && _mergedResults$get !== void 0 ? _mergedResults$get : {}, result));
    });
  });
  return Array.from(mergedResults.values());
}